// Shared email validator for every email input in the app (rule 4).
//
// TWIN FILE: supabase/functions/_shared/emailValidation.ts holds the same
// logic and the same EMAIL_ERROR_MESSAGE for edge functions (CRA cannot import
// from supabase/, Deno cannot import from src/). Keep them in sync;
// emailValidation.test.js runs one fixtures file against both.
//
// Rules (format only): trim; max 254 chars; no whitespace; exactly one "@";
// non-empty local part; domain with at least one dot that does not start or
// end with a dot. Stored values are NOT lowercased.

export const EMAIL_ERROR_MESSAGE = 'Please enter a valid email address.'

export function normalizeEmail(raw) {
  return typeof raw === 'string' ? raw.trim() : ''
}

function isValidFormat(email) {
  if (!email || email.length > 254) return false
  if (/\s/.test(email)) return false
  const parts = email.split('@')
  if (parts.length !== 2) return false
  const local = parts[0]
  const domain = parts[1]
  if (!local) return false
  if (!domain.includes('.')) return false
  if (domain.startsWith('.') || domain.endsWith('.')) return false
  return true
}

export function validateEmail(raw) {
  const email = normalizeEmail(raw)
  if (!isValidFormat(email)) return { ok: false, email, error: EMAIL_ERROR_MESSAGE }
  return { ok: true, email, error: null }
}
